"use strict";
// automatically generated by the FlatBuffers compiler, do not modify
Object.defineProperty(exports, "__esModule", { value: true });
exports.TemperatureT = exports.Temperature = void 0;
/**
 * Temperature in degrees celsius
 */
class Temperature {
    constructor() {
        this.bb = null;
        this.bb_pos = 0;
    }
    __init(i, bb) {
        this.bb_pos = i;
        this.bb = bb;
        return this;
    }
    temp() {
        return this.bb.readFloat32(this.bb_pos);
    }
    static sizeOf() {
        return 4;
    }
    static createTemperature(builder, temp) {
        builder.prep(4, 4);
        builder.writeFloat32(temp);
        return builder.offset();
    }
    unpack() {
        return new TemperatureT(this.temp());
    }
    unpackTo(_o) {
        _o.temp = this.temp();
    }
}
exports.Temperature = Temperature;
class TemperatureT {
    constructor(temp = 0.0) {
        this.temp = temp;
    }
    pack(builder) {
        return Temperature.createTemperature(builder, this.temp);
    }
}
exports.TemperatureT = TemperatureT;
